export { C as default } from "../countryflag-9c02eba3.js";
import "react";